"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAndDispatchEvent = exports.eventNames = void 0;
const lodash_1 = require("lodash");
exports.eventNames = {
    Bonus: 'Bonus',
    DrawResult: 'DrawResult',
    JackpotWon: 'JackpotWon',
    SetConfiguration: 'SetConfiguration',
    SetContent: 'SetContent',
    SetJackpotWin: 'SetJackpotWin',
    SetResults: 'SetResults',
    SetState: 'SetState',
    SetStatus: 'SetStatus',
    StartCountdown: 'StartCountdown',
    StartEvent: 'StartEvent',
    StartRace: 'StartRace',
    StopBetting: 'StopBetting',
    TicketRebet: 'TicketRebet',
    TicketUpdate: 'TicketUpdate',
    UpdateBalance: 'UpdateBalance',
    UpdateJackpot: 'UpdateJackpot',
    UpdateJackpotAmount: 'UpdateJackpotAmount',
    SetIdle: 'SetIdle',
    SetStep: 'SetStep',
    FinishEvent: 'FinishEvent',
};
const eventNameMap = {
    ajs_config_change: exports.eventNames.UpdateJackpot,
    ajs_amount_update: exports.eventNames.UpdateJackpotAmount,
    ajs_amount_change: exports.eventNames.UpdateJackpotAmount,
    ajs_win: exports.eventNames.SetJackpotWin,
    balanceChanged: exports.eventNames.UpdateBalance,
    ball: exports.eventNames.DrawResult,
    bettingDisabled: exports.eventNames.StopBetting,
    bonus: exports.eventNames.Bonus,
    config: exports.eventNames.SetConfiguration,
    contentStatus: exports.eventNames.SetStatus,
    countdown: exports.eventNames.StartCountdown,
    draw: exports.eventNames.DrawResult,
    fetchContent: exports.eventNames.SetContent,
    new: exports.eventNames.StartEvent,
    newConfig: exports.eventNames.SetConfiguration,
    race: exports.eventNames.StartRace,
    results: exports.eventNames.SetResults,
    shoot: exports.eventNames.StartEvent,
    state: exports.eventNames.SetState,
    ticketRebet: exports.eventNames.TicketRebet,
    ticketUpdate: exports.eventNames.TicketUpdate,
    init: exports.eventNames.SetState,
    idle: exports.eventNames.SetIdle,
    start: exports.eventNames.StartEvent,
    step: exports.eventNames.SetStep,
    crash: exports.eventNames.FinishEvent,
    finish: exports.eventNames.FinishEvent,
};
const parseTournamentData = (rawEvent, rawData) => {
    const data = lodash_1.merge(rawData, {
        sentTime: new Date(rawData.sentTime).toISOString(),
        time: new Date(rawData.time).toISOString(),
        tournamentDisplayId: rawData.tournamentIdToday,
    });
    return lodash_1.omit(data, ['tournamentIdToday', 'type']);
};
const parseData = (rawEvent, rawData) => {
    /*
    We are using property detection to parse data by game type.
    */
    if (rawData.tournamentId) {
        return parseTournamentData(rawEvent, rawData);
    }
    return rawData;
};
exports.parseAndDispatchEvent = (rawEventName, rawData, useCommonEventName, sourceAdapter, proxyEvents, bounceToFrames) => {
    let eventName = lodash_1.defaultTo(eventNameMap[rawEventName], rawEventName);
    if (lodash_1.isNil(exports.eventNames[rawEventName]) && lodash_1.isNil(eventNameMap[rawEventName])) {
        console.warn(`[BusService]: Unknown ${rawEventName} event:`, rawData);
    }
    let isProxyEvent = false;
    if (proxyEvents && proxyEvents.length > 0) {
        const proxyEventIndex = proxyEvents.findIndex((n) => n.source === eventName);
        if (proxyEventIndex >= 0) {
            eventName = proxyEvents[proxyEventIndex].target;
            isProxyEvent = true;
        }
    }
    const unifyEventName = useCommonEventName && !isProxyEvent;
    const uniqueEventName = unifyEventName ? 'Bus:Message' : `Bus:${eventName}`;
    const eventDetail = lodash_1.merge({
        eventName,
        rawEventName,
        rawData,
        sourceAdapter,
    }, {
        ...parseData(rawEventName, rawData),
    });
    const event = new CustomEvent(uniqueEventName, {
        detail: eventDetail,
    });
    window.dispatchEvent(event);
    if (window.document && bounceToFrames && bounceToFrames.length > 0) {
        bounceToFrames.forEach((bounceFrame) => {
            const frame = window.document.getElementById(bounceFrame.frameId);
            if (frame && frame.contentWindow) {
                try {
                    frame.contentWindow.postMessage(eventDetail, '*');
                }
                catch (error) {
                    console.warn(`[BusService]: Error bouncing message to ${bounceFrame.frameId} frame.`, error);
                }
            }
        });
    }
};
//# sourceMappingURL=ParserService.js.map